import { render, staticRenderFns } from "./common-entities.vue?vue&type=template&id=324f3c20&scoped=true"
import script from "./common-entities.ts?vue&type=script&lang=ts&external"
export * from "./common-entities.ts?vue&type=script&lang=ts&external"
import style0 from "./common-entities.less?vue&type=style&index=0&id=324f3c20&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f3c20",
  null
  
)

export default component.exports